/** `deal_service.LOCAL_SHEET_URL_TEMPLATE`: the download path of an offering sheet built as a file, in development. */
const LOCAL_SHEET_LINK =
  /^\/api\/admin\/forwards\/deals\/\d+\/offering-sheets\/[\w.-]+$/;

/** `deal_service.SINGLE_WEB_LINK`. */
const SINGLE_WEB_LINK = /^https?:\/\/[^\s,/?#]+[^\s,]*$/i;

/**
 * Whether an offering-sheet link is a file on this site rather than a web link. A plain anchor cannot
 * open it — the navigation carries no bearer token — so the deal page fetches it instead.
 */
export const isLocalSheetLink = (link: string): boolean =>
  LOCAL_SHEET_LINK.test(link);

/**
 * Whether a deal's transaction link is blank or one http or https link, as the backend requires: it
 * becomes the `href` of the sales history date that producers and corporations click.
 */
export const isSingleWebLinkOrBlank = (value: string): boolean => {
  const link = value.trim();
  return link.length === 0 || SINGLE_WEB_LINK.test(link);
};
